var PickupPointsHelper = (function ($, ListHelper, MapHelper) {

	var viewMode = {
		list: 1,
		map: 2
	};

	var pickupPoints = function (options) {
		this.el = options.el;
		this.switcher = options.switcher;
		this.mapTab = options.mapTab;
		this.listTab = options.listTab;

		this.mapCanvas = options.mapCanvas;

		this.pickupListCanvas = options.pickupListCanvas;

		this._hiddenClassName = options.hiddenClassName;
		this._selectCallback = options.selectCallback;

		this.viewMode = viewMode.list;

		this.listHelper = new ListHelper(options.pickupListCanvas, options.getPickupInfoHtml, options.getNoPickupMessageHtml, this._currentListItemChanged.bind(this));
		if (options.displayMap) {
			this._initWithMap(options);
		} else {
			this._initWithoutMap();
		}
	};

	pickupPoints.prototype = {
		_initWithMap: function (o) {
			this.mapHelper = new MapHelper(o.mapCanvas, o.key, o.countryID, o.coordinates_changed, o.getMarkerInfoHtml, this._currentMarkerChanged.bind(this));
		    this.mapHelper.ready()
		        .done(_.bind(function() {
		            this.listTab.onclick = _.bind(this.toggleList, this, true);
		            this.mapTab.onclick = _.bind(this.toggleMap, this, true);
		        }, this))
		        .fail(_.bind(function() {
		            this.mapHelper = null;
		            this._initWithoutMap();
		        }, this));
		},
		_initWithoutMap: function () {
			this.switcher.classList.add(this._hiddenClassName);
			this.toggleList(true);
		},

		clear: function() {
			this.hide();
			this.viewMode = viewMode.list;
			this.current = null;
		},

		hide: function() {
			this.toggleEl(false);
		},

		show: function () {
			this.listTab.classList[(this.viewMode === viewMode.map ? 'remove' : 'add')]('pickup-point-switcher_item__selected');
			this.mapTab.classList[(this.viewMode === viewMode.list ? 'remove' : 'add')]('pickup-point-switcher_item__selected');

			this.mapTab.isActive = this.viewMode === viewMode.map;

			this.pickupListCanvas.classList[(this.viewMode === viewMode.list ? 'remove' : 'add')](this._hiddenClassName);
			this.mapCanvas.classList[(this.viewMode === viewMode.map ? 'remove' : 'add')](this._hiddenClassName);
			this.toggleEl(true);

			this.mapHelper && this.viewMode === viewMode.map && this.mapHelper.resize();
		},

		toggleList: function(display) {
			this.viewMode = display ? viewMode.list : viewMode.map;
			this.show();
		},

		toggleMap: function(display) {
			this.viewMode = display ? viewMode.map : viewMode.list;
			this.show();
		},

		toggleEl: function(display) {
			this.el.classList[(display ? 'remove' : 'add')](this._hiddenClassName);
		},

		_currentMarkerChanged: function (data) {
			this._setCurrent(data);
			this.listHelper.setCurrent(data);
		},

		_currentListItemChanged: function(data) {
			this._setCurrent(data);
			this.mapHelper && this.mapHelper.setCurrent(data, true);
		},

		_setCurrent: function (data) {
			this._selectCallback(data);
			this.current = data;
		},

		_selectCallback: function(data) {
			throw new Error('You must define method _selectCallback!');
		},

		setPickupPoints: function (pickupPoints, updatePossition) {

			if (this.mapHelper) {
				this.mapHelper.updatePossition = updatePossition;
				this.mapHelper.addMarkers(pickupPoints);
			}

			this.listHelper.addPickupPoints(pickupPoints);

			if (this.current) {
				this.listHelper.setCurrent(this.current);
				this.mapHelper && this.mapHelper.setCurrent(this.current, false);
			}

			this.show();
		}
	};

	return pickupPoints;

})(jQuery, ListHelper, MapHelper);